// Translation calls for every page surface: keys live in config/locales/<scope>/en.yml and start
// with their scope, so one function serves every page. A file calling t imports its scope's
// en.wjs itself (bin/localize-mailer adds it), so English is there before setPageLang.
import { LOADERS } from 'js/i18n/page_translations/index';
import { pageTranslation } from 'js/intl/isolatedTranslate';

const page = pageTranslation(LOADERS);

export const t = page.t;
export const tPlural = page.tPlural;
// Switches every page surface's copy to a lang, loading it first; call it once, before rendering,
// wherever the page knows the visitor's lang. 'en' or an unshipped lang switches back to English.
// Client-rendered pages only: a server renderer would share the lang across requests.
export const setPageLang = page.applyLang;
